<template>
    <div class="shadow-md p-3">
  
      <div class="modal" id="imageDialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <!-- Modal body -->
              <div class="modal-body">
                <img :src="selectedImage" class="d-block w-full max-h-[600px] object-contain" alt="Larger Image" />
              </div>
          </div>
        </div>
      </div>
      
      <div class="w-full flex flex-wrap" id="top">
        <div :class="itemEditable.IDART_IO ? 'w-full md:w-1/2' : 'w-full'" class="order-2 order-md-1">
          <div>
              <h1 style="font-size: 25px;" class="!text-larger">Descargar certificado</h1>
              <div class="flex gap-2">
                <input @change="buscadorFiltros()" type="text" v-model="buscador" placeholder="Codigo del articulo..." class="form-control w-44">
                <button :disabled="cargando" @click="buscadorFiltros(1)" class="btn btn-success btn-sm">Buscar</button>
            </div>
          </div>
          <div>
            <table class="table table-striped table-sm text-xs">
              <thead>
                <tr>
                  <th scope="col">Descargar</th>
                  <th scope="col">Codigo</th>
                  <th scope="col">Nombre</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in items" :key="key" class="">
                  <td @click="descargar(item.ID_ART);" class="!cursor-pointer">
                    <button class="w-7 mr-1"><img src="../assets/icons/correo.png" alt="Editar" title="Descargar"></button>
                    <p>Descargar certificado</p>
                    <!-- <button class="w-7"><img src="../assets/icons/bin.png" alt="Eliminar" title="Eliminar"></button> -->
                  </td>
                  <!-- <td class="clickable" @click="openImageDialog(item.imagenPrincipal.split('|')[0])">
                      <div v-if="!item.imagenPrincipal || !item.imagenPrincipal.split('|')[0]">
                          <img class="d-block w-24 max-h-24 object-contain" src="../assets/no-photo.jpg" alt="Imagen del articulo" />
                      </div>
                      <div v-else>
                          <img 
                              :src="item.imagenPrincipal.split('|')[0]" 
                              :alt="'Imagen del articulo'" 
                              class="d-block w-24 max-h-24 object-contain m-auto" 
                          />
                      </div>
                  </td> -->
                  <td>{{ item.CODIGO_ART }}</td>
                  <td >{{ item.DESCRIP_ART }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import pedidosService from '@/services/pedidos.service';

  
  export default {
    data() {
      return {
        arts: [],
        itemEditable: {},
        items: [],
        categorias: [],
        categoriasOrdenadas: [],
        buscador: '',
        buscadorPrecio: null,
        buscadorEstado: '1',
        buscadorMarca: null,
        buscadorCat: null,
        buscadorSubCat: null,
        cargando: false,
        filtroBusqueda: "",
        tipoFiltro: "",
        ultimoIndex: 1,
        cambioFoto: false,
        keyImg: '',
        file: null,
        imagenTemp: '',
        cantPaginas: 1,
        selectedImage: ''
      };
    },
    methods: {
      openImageDialog(imageUrl) {
          this.selectedImage = imageUrl; // Set the selected image URL
          window.$('#imageDialog').modal('show');
          // Show the dialog
      },
      closeImageDialog() {
        window.$('#imageDialog').modal('hide'); // Hide the dialog
        this.selectedImage = ''; // Clear the selected image
      },
      
      buscadorFiltros() {
        this.cargando = true
        pedidosService.getProductoExacto(this.buscador)
          .then(res => {
            if (res.data.CODIGO_ART) {
              this.items = [res.data]
            } else {
              this.items = []
            }
            this.cargando = false
          })
          .catch((err) => {
            console.log(err)
            this.cargando = false
          })
      },
      isImage(url) {
        return url && url.endsWith("image");
      },
      descargar(idart) {
        window.scrollTo(0,0);
        this.cargando = true
        pedidosService.generarCertificado(idart)
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', 'certificado.pdf'); // Set the filename for the downloaded file
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((er) => {
          alert('No se encontro el certificado')
          console.log(er)
        })
        .finally(() => {
          this.cargando = false
        })
      },
      editarItemInstancia(index) {
        this.itemEditable = this.items[index]
        this.itemEditable.ACTIVO_IO = false
        this.itemEditable.DESTACADO_IO = false
        this.itemEditable.OFERTA_IO = false
      },
      buscarImagenes() {
        for (var i = 1; i < 6; i++) {
          if (this.itemEditable['FOTO' + i + '_IO']) {
            this.imagenes(i)
          }
        }
      },
      imagenes(i, idart) {
        pedidosService
        .getImagenProducto((idart ? idart : this.itemEditable.IDART_IO), i)
        .then((res) => {
          const contentType = res.headers["content-type"];
  
          if (
            contentType && (contentType.startsWith("image/") || contentType.startsWith("video/"))) {
            const mediaBlob = new Blob([res.data], { type: contentType });
            const mediaObjectURL = URL.createObjectURL(mediaBlob);
            const blobUrlWithExtension = `${mediaObjectURL}|${i}|${
              contentType.startsWith("image/") ? "image" : "video"
            }`;
            if (idart) {
              this.items.find(itm => itm.IDART_IO == idart).imagenPrincipal = blobUrlWithExtension
            } else {
              this.itemEditable['imagen' + i] = blobUrlWithExtension
            }
          } else {
            if (res.data.byteLength === 0 && i != null) {
              if (idart) {
                this.items.find(itm => itm.IDART_IO == idart).imagenPrincipal = ('|' + 1)
              } else {
                this.itemEditable['imagen' + i] = ('|' + i);
              }
            } else {
              console.error(
                "The response does not contain valid media data. Content-Type:",
                contentType
              );
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
      },
      getAllCategorias() {
          this.buscadorFiltros(1)
      },
      resetFiltros() {
        this.orden = "pd";
        this.buscador = "";
        this.filtroBusqueda = "";
      },
      cambioBuscador(index) {
        if (this.buscador) {
          this.cargando = true;
          var buscador = this.buscador;
          this.resetFiltros();
          this.buscador = buscador;
          pedidosService
            .getProductosConIndexBusqueda(index, this.buscador)
            .then((res) => {
              this.cargando = false;
              if (res.data.length == 0) {
                this.ultimoIndex > 1 ? this.ultimoIndex-- : ''
                return
              }
              if (this.tipoFiltro != "+++buscador") {
                this.items = [];
                this.ultimoIndex = 1
  
              }
              this.filtroBusqueda = this.buscador;
              this.items = res.data
              this.items.forEach(i => {
                this.cargarPrimerImagen(i)
              })
              this.tipoFiltro = "+++buscador";             
            })
            .catch((err) => {
              console.log(err);
              this.cargando = false;
            });
        } else {
          this.cargarProductos(1);
        }
      },
      cargarProductos(index) {
        this.cargando = true;
        this.resetFiltros();
        pedidosService
          .getProductosConIndex(index)
          .then((res) => {
            this.inde
            this.cargando = false;
            if (res.data.length == 0) {
              this.ultimoIndex > 1 ? this.ultimoIndex-- : ''
              return
            }
            if (this.tipoFiltro != "") {
              this.items = [];
              this.ultimoIndex = 1
  
            }
            this.filtroBusqueda = "";
            this.items = res.data
            this.items.forEach(i => {
              this.cargarPrimerImagen(i)
            })
            this.tipoFiltro = "";
            this.ultimoIndex = index
            this.cantPaginas = Math.ceil(res.data[0].cantPaginas / 25)
            
          })
          .catch((err) => {
            console.log(err);
            this.cargando = false;
          });
      },
      cargarPrimerImagen(i) {
        this.imagenes(1, i.IDART_IO)
      }
    },
  };
  </script>
  
  <style>
  /* .modal {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1000;
  } */
  .modal-dialog {
      background: white;
      border-radius: 8px;
      padding: 20px;
  }
  .clickable:hover {
    cursor: pointer;
  }
  </style>
  
  